function updateFnNewCollectionsSliderArrows(swiper) {
  const nav = swiper.el.querySelector('.swiper_navigation_block');
  if (!nav) return;

  const slideCount = swiper.slides.length;
  let perView = parseFloat(swiper.params.slidesPerView, 10);
  if (Number.isNaN(perView)) perView = 1;

  nav.classList.toggle('swiper_navigation_block--no-arrows', slideCount <= perView);
}

function initFnNewCollectionsSliderRoot(root) {
  const slider = root.querySelector('.section_slider-swiper');
  if (!slider || !slider.id || typeof Swiper === 'undefined') return;
  if (slider.swiper) slider.swiper.destroy(true, true);

  new Swiper('#' + slider.id, {
    slidesPerView: 1.4,
    spaceBetween: 15,
    breakpoints: {
      576: { slidesPerView: 2, spaceBetween: 15 },
      768: { slidesPerView: 3, spaceBetween: 15 },
      992: { slidesPerView: 4, spaceBetween: 24 },
    },
    navigation: {
      nextEl: '#' + slider.id + ' .swiper-button-next',
      prevEl: '#' + slider.id + ' .swiper-button-prev',
    },
    pagination: {
      el: '#' + slider.id + ' .swiper-pagination',
      clickable: true,
    },
    on: {
      init() {
        updateFnNewCollectionsSliderArrows(this);
      },
      resize() {
        updateFnNewCollectionsSliderArrows(this);
      },
      breakpoint() {
        updateFnNewCollectionsSliderArrows(this);
      },
    },
  });
}

function initFnNewCollectionsSliders(scope) {
  const container = scope || document;
  container.querySelectorAll('[data-fn-new-collections]').forEach(initFnNewCollectionsSliderRoot);
}

function bootFnNewCollectionsSliders() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initFnNewCollectionsSliders());
  } else {
    initFnNewCollectionsSliders();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initFnNewCollectionsSliders(event.target);
  });
}

bootFnNewCollectionsSliders();
